import { useSyncExternalStore } from "react";

// ----------------------------------------------------------------------
// Hydration-safe media-query hook. Reads the live `matchMedia` result via
// useSyncExternalStore so there is no effect and no set-state-in-effect —
// the server/pre-hydration snapshot is always `false`. Shared by the navbar
// and the home-page teasers.
// ----------------------------------------------------------------------

export default function useMediaQuery(query: string) {
  return useSyncExternalStore(
    (callback) => {
      const mediaQueryList = window.matchMedia(query);
      mediaQueryList.addEventListener("change", callback);
      return () => mediaQueryList.removeEventListener("change", callback);
    },
    () => window.matchMedia(query).matches,
    () => false // SSR/pre-hydration snapshot
  );
}
